import { AppstoreOutlined } from '@ant-design/icons';
import { Tooltip, Typography } from 'antd';
import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';

import { DashboardItems } from '../Config';

interface DashboardItemProps {
  item: DashboardItems;
}

const DashboardItem: React.FC<DashboardItemProps> = React.memo(({ item }) => {
  const chipRef = useRef<HTMLDivElement>(null);

  return (
    <Tooltip>
      <NavLink
        to={item.path}
        className="host-flex host-flex-col host-items-center"
        style={{ textDecoration: 'none', width: 88 }}
        onMouseEnter={() => {
          if (chipRef.current) chipRef.current.style.transform = 'translateY(-4px) scale(1.05)';
        }}
        onMouseLeave={() => {
          if (chipRef.current) chipRef.current.style.transform = 'translateY(0) scale(1)';
        }}
      >
        <div
          ref={chipRef}
          style={{
            background: 'rgba(255,255,255,0.92)',
            borderRadius: 18,
            width: 64,
            height: 64,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            transition: 'transform 200ms ease-out, box-shadow 200ms ease-out',
            transformOrigin: 'center',
            willChange: 'transform',
          }}
        >
          {item.icon ? item.icon : <AppstoreOutlined style={{ color: '#9ca3af', fontSize: 28 }} />}
        </div>

        <Typography.Text
          className="host-mt-2 host-text-xs host-font-medium host-text-center"
          style={{ color: '#ffffff', textShadow: '0 1px 3px rgba(0,0,0,0.5)' }}
        >
          {item.label}
        </Typography.Text>
      </NavLink>
    </Tooltip>
  );
});

DashboardItem.displayName = 'DashboardItem';

export default DashboardItem;
